import { NavLink, useLocation } from '@redwoodjs/router'

export type SectionNavItem = {
  label: string
  route: string
  /**
   * Keeps the item active across a sub-page's own routes — a carrier detail at
   * /admin/voe/carriers/:carrierId still belongs to the Carriers tab.
   */
  matchPrefix?: string
}

interface SectionNavProps {
  heading: string
  items: SectionNavItem[]
}

const SectionNav = ({ heading, items }: SectionNavProps) => {
  const { pathname } = useLocation()

  return (
    <nav
      aria-label={heading}
      className="flex w-[200px] flex-none flex-col gap-1 border-r border-doubleNickel-gray-200 pr-4 text-xs text-doubleNickel-gray-500"
    >
      <div className="py-1 uppercase">{heading}</div>
      {items.map((item) => {
        const isActive = item.matchPrefix
          ? pathname === item.matchPrefix ||
            pathname.startsWith(`${item.matchPrefix}/`)
          : pathname === item.route
        return (
          <NavLink
            key={item.route}
            to={item.route}
            aria-current={isActive ? 'page' : undefined}
            activeClassName=""
            className={`rounded px-2 py-1 font-medium ${
              isActive
                ? 'bg-doubleNickel-gray-100 font-semibold text-doubleNickel-gray-700'
                : 'text-doubleNickel-gray-500 hover:text-doubleNickel-gray-700'
            }`}
          >
            {item.label}
          </NavLink>
        )
      })}
    </nav>
  )
}

export default SectionNav
